"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.provider.stripe.description': 'Paga con tarjetas de crédito, débito y carteras digitales usando Stripe',
};
